<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>供应系统</el-breadcrumb-item>
        <el-breadcrumb-item>供应点管理</el-breadcrumb-item>
        <el-breadcrumb-item>退货退款记录</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="hx-form-container box-shadow">
      <el-form :model="listParams" label-width="100px">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="领货日期：">
              <el-select clearable style="width: 100%" v-model="listParams.date" placeholder="请选择领货日期" size="small">
                <el-option v-for="item in dateList" :value="item.dateId" :key="item.dateId" :label="item.date | formatDate"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item>
              <el-button size="small" type="primary" @click="loadTableData"> 查询 </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <hx-table-result :page-info="pager" :loading="tableLoading" @page-current-change="handleCurrentChange" @page-size-change="handleSizeChange">
      <div slot="action"></div>

      <el-table slot="content" :data="tableData" max-height="800" border>
        <el-table-column align="center" width="60" label="序号">
          <template slot-scope="scope">
            <span v-text="(pager.pageIndex > 1 ? (pager.pageIndex - 1) * pager.pageSize : 0) + scope.$index + 1"> </span>
          </template>
        </el-table-column>

        <el-table-column prop="orderNo" align="center" label="订单编号"> </el-table-column>

        <el-table-column prop="mobile" align="center" label="手机号"> </el-table-column>

        <el-table-column prop="goodsTitle" align="center" label="菜品名称"> </el-table-column>

        <el-table-column prop="specTitle" align="center" label="规格"> </el-table-column>

        <el-table-column prop="quantity" align="center" label="数量"> </el-table-column>

        <el-table-column prop="price" align="center" label="价格"> </el-table-column>

        <el-table-column prop="returnCause" align="center" label="退货原因">
          <template slot-scope="scope">
            <span v-if="scope.row.returnCause">
              <span v-if="scope.row.returnCause.length > 10">
                <el-popover placement="top-start" width="200" trigger="hover" :content="scope.row.returnCause">
                  <el-button style="color: #606266" type="text" slot="reference">
                    {{ scope.row.returnCause | formatLimitLength }}
                  </el-button>
                </el-popover>
              </span>
              <span v-else>
                <span>{{ scope.row.returnCause }}</span>
              </span>
            </span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <confirm-button v-if="scope.row.revocation === 1" type="text" style="margin: 0 10px" title="确认要撤销该条数据？" @confirmed="repealItem(scope.row.id)">
              <span>撤销</span>
            </confirm-button>
            <el-tooltip effect="dark" content="该数据不可撤销" placement="top">
              <el-button type="text" disabled>撤销</el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </hx-table-result>
  </div>
</template>

<script>
export default {
  data() {
    return {
      listParams: {
        date: "",
        id: "",
      },
      dateList: [],
      tableLoading: false,
      tableData: [],
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0,
      },
    };
  },
  mounted() {
    this.loadDateList();
    this.loadTableData();
  },
  methods: {
    /**
     * 初始化领货日期
     */
    loadDateList() {
      this.$http({
        url: global.apiUrl + "/logistics/goods-management-date",
        method: "GET",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            if (res.body.data) {
              this.dateList = res.body.data.dateList;
            } else {
            }
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 初始化列表数据
     */
    loadTableData() {
      this.tableLoading = true;
      this.$http({
        url: global.apiUrl + "/logistics/return",
        method: "GET",
        params: this.listParams,
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableLoading = false;
            if (res.body.data) {
              this.tableData = res.body.data.dataList;
              this.pager.total = res.body.data.total;
            } else {
              this.tableData = [];
            }
          } else {
            this.tableLoading = false;
          }
        })
        .catch(err => {
          this.tableLoading = false;

          console.error(err);
        });
    },
    /**
     * 核销订单
     */
    cancelOrder() {},
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    },
    /**
     * 撤销条目数据
     * @param id
     */
    repealItem(id) {
      this.$http({
        url: global.apiUrl + "/logistics/return-delete",
        method: "DELETE",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.$message.success(res.body.info);
            this.loadTableData();
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.listParams.id = parseInt(vm.$route.params.supplyId);
    });
  },
};
</script>

<style lang="less" scoped>
.home-container {
  .alert-text {
    color: #e9a021;
    cursor: default;
  }
}
</style>
